import { WorkoutScreen, NutritionScreen, AiCoachScreen, ExerciseSwapScreen, FoodSwapScreen } from "./screens1";
import { CoachGuidedScreen, ClassicTrackerScreen, ProgressScreen, HabitsScreen, RecipesScreen } from "./screens2";
import { CustomPlanScreen, AdaptationScreen, LearningHubScreen } from "./screens3";

export const SCREEN_REGISTRY = {
    "01-workout": WorkoutScreen,
    "02-nutrition": NutritionScreen,
    "03-ai-coach": AiCoachScreen,
    "04-exercise-swap": ExerciseSwapScreen,
    "05-food-swap": FoodSwapScreen,
    "06-coach-guided": CoachGuidedScreen,
    "07-classic-tracker": ClassicTrackerScreen,
    "08-progress": ProgressScreen,
    "09-habits": HabitsScreen,
    "10-recipes": RecipesScreen,
    "11-custom-plan": CustomPlanScreen,
    "12-adaptation": AdaptationScreen,
    "13-learning-hub": LearningHubScreen,
};
